
export default function importExternalScript(link) {
  let existsScript = false;
  const scripts = document.getElementsByTagName('script');
  for (let i = scripts.length; i--;) {
    if (scripts[i].src === link) {
      existsScript = true
      break
    }
  }
  if (!existsScript) {
    const script = document.createElement('script')
    script.setAttribute('src', link)
    script.setAttribute('target', 'importExternalScript')
    document.head.appendChild(script)
  }
}
